var LiveStatsDataBuilder = /** @class */ (function () {
    function LiveStatsDataBuilder() {
        this.liveStatsData = {
            waiting: 4,
            inProgress: 9,
            maxWaitingStartDate: Date.now() - 2000,
            timeframeRequests: 3,
        };
    }
    LiveStatsDataBuilder.prototype.withWaiting = function (waiting) {
        this.liveStatsData.waiting = waiting;
        return this;
    };
    LiveStatsDataBuilder.prototype.withInProgress = function (inProgress) {
        this.liveStatsData.inProgress = inProgress;
        return this;
    };
    LiveStatsDataBuilder.prototype.withMaxWaitingStartDate = function (date) {
        this.liveStatsData.maxWaitingStartDate = date;
        return this;
    };
    LiveStatsDataBuilder.prototype.withTimeframeRequests = function (timeframeRequests) {
        this.liveStatsData.timeframeRequests = timeframeRequests;
        return this;
    };
    LiveStatsDataBuilder.prototype.build = function () {
        return this.liveStatsData;
    };
    return LiveStatsDataBuilder;
}());
export { LiveStatsDataBuilder };
//# sourceMappingURL=live-stats-data.builder.js.map